import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Grid, GridProps } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => createStyles({
	root: {
		alignItems: 'center',
		backgroundColor: theme.palette.common.white,
		flexDirection: 'row',
		justifyContent: 'space-between',
		gap: theme.spacing(1),
		padding: theme.spacing(0, 2, 2),
		width: '100%',
	},
}));

const AlertDetails: React.FC<GridProps> = ({ children, className, ...props }) => {
	const classes = useStyles();

	return (
		<Grid
			container
			className={classNames(classes.root, className)}
			{...props}
		>
			{children}
		</Grid>
	);
};

export default AlertDetails;
